import { render, staticRenderFns } from "./l-suave.vue?vue&type=template&id=0399d0be&lang=pug&"
import script from "./l-suave.vue?vue&type=script&lang=js&"
export * from "./l-suave.vue?vue&type=script&lang=js&"
import style0 from "./l-suave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0399d0be')) {
      api.createRecord('0399d0be', component.options)
    } else {
      api.reload('0399d0be', component.options)
    }
    module.hot.accept("./l-suave.vue?vue&type=template&id=0399d0be&lang=pug&", function () {
      api.rerender('0399d0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/l-suave.vue"
export default component.exports